export const getMappedIconsFromImport = (icons: any) => icons.keys()
  .reduce((accu: any, path: any) => {
    accu[path.match(/\/(.*?)\./)[1]] = icons(path).default;
    return accu;
  }, {});
